import { useEffect, useState } from "react";
import { fetchCurrencies, downloadCurrenciesExcel } from "../Api/ViewCurrencyMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewCurrencyMaster = () => {
  const [currencies, setCurrencies] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadCurrencies = async () => {
      try {
        const data = await fetchCurrencies();
        setCurrencies(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Currency Data`);
      }
    };

    loadCurrencies();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadCurrenciesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'CurrencyMaster_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Currency data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="">
          <Container  className="list-container">
            <div className="header-background">
              <span className="header-list-title">View Currency Master</span>
              <Button className="gradient-btn"
                // variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || currencies.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {currencies.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Currency Code ID</th>
                        <th>Currency Code</th>
                        <th>Currency Name</th>
                        <th>Symbol</th>
                        <th>ISO Code</th>
                        <th>Decimal Places</th>
                        <th>Exchange Rate Type</th>
                        <th>Country</th>
                        <th>Exchange Rate</th>
                        <th>Status</th>
                        <th>Effective From</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currencies.map((currency, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{currency.currencyCodeId}</td>
                          <td>{currency.currencyCode}</td>
                          <td>{currency.currencyName}</td>
                          <td>{currency.symbol}</td>
                          <td>{currency.isoCode}</td>
                          <td>{currency.decimalPlaces}</td>
                          <td>{currency.exchangeRateType}</td>
                          <td>{currency.country}</td>
                          <td>{currency.exchangeRate}</td>
                          <td>{currency.status}</td>
                          <td>{moment(currency.effectiveFromDate).format('L')}</td>
                          <td>{moment(currency.createdAt).format('L')}</td>
                          <td>{currency.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No currency data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewCurrencyMaster;